// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"171":"a60b00cb","429":"c64dad0f","432":"5af73a8f","453":"b03e3c98","507":"0265d24e","555":"ce4a4633","707":"a411c923","923":"f5c6498e","978":"176d2b83"}[chunkId] + ".chunk.js";
};